import React, { useState, useEffect } from 'react';
import SkeletonRowLoader from '../SkeletonRowLoader';
import Storage from '../../wp_helpers/storage';

const getStoredTab = (key) => Storage.tab.getItem(key);

const setStoredTab = (key, tabID) => {
    Storage.tab.setItem(key, tabID);
};

const Tabs = ({ tabLabels, tabIDs, data, layoutMapping, onTabChange, persistTabKey }) => {
    const getInitialTab = () => {
        if (tabIDs.length === 0) return '';
        if (persistTabKey) {
            const stored = getStoredTab(persistTabKey);
            if (stored && tabIDs.includes(stored)) return stored;
        }
        return tabIDs[0] || '';
    };

    const [activeTabID, setActiveTabID] = useState(getInitialTab);

    useEffect(() => {
        if (tabIDs.length === 0) return;
        const stored = persistTabKey ? getStoredTab(persistTabKey) : null;
        const next = (stored && tabIDs.includes(stored)) ? stored : tabIDs[0];
        setActiveTabID(next);
    }, [tabIDs, persistTabKey]);

    const handleTabClick = (tabID) => {
        setActiveTabID(tabID);
        if (persistTabKey) setStoredTab(persistTabKey, tabID);
        if (onTabChange) {
            onTabChange(tabID);
        }
    };

    const renderTabContent = () => {
        const ContentLayout = layoutMapping[activeTabID];
        if (ContentLayout) {
            const contentProps = data[activeTabID];
            return <ContentLayout {...contentProps} />;
        } else {
            return <SkeletonRowLoader count={12} />;
        }
    };

    return (
        <div className="tabs-container">
            <div className="tabs">
                {tabIDs.map((tabID, index) => (
                    <a
                        key={tabID}
                        className={tabID === activeTabID ? 'is-active' : ''}
                        onClick={() => handleTabClick(tabID)}
                        data-tab_text={tabLabels[index]}
                    >
                        {tabLabels[index]}
                    </a>
                ))}
            </div>
            <div className="tab-content">{renderTabContent()}</div>
        </div>
    );
};

export default Tabs;
